import { MailCheck } from "lucide-react";
import { useState } from "react";
import { Button } from "../ui/button";
import { LoadingButton } from "../ui/loading-button";
import { StatusMessage } from "../ui/status-message";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Shown after sign-up succeeds, in place of the form.
 *
 * Sign-up used to leave the filled-in form on screen with a one-line status
 * message under the submit button, which read as "nothing happened" — the user
 * has to go to their inbox, and the UI has to say so unmistakably.
 */
export function CheckEmailPanel({
  email,
  onResend,
  onDone,
  doneLabel = "Stäng"
}) {
  const [resending, setResending] = useState(false);
  const [resendState, setResendState] = useState(null);
  const handleResend = async () => {
    if (!onResend) return;
    setResending(true);
    try {
      setResendState(await onResend());
    } finally {
      setResending(false);
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "space-y-6 text-center",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex justify-center",
      children: /*#__PURE__*/_jsx("div", {
        className: "rounded-full bg-blue-50 p-4",
        children: /*#__PURE__*/_jsx(MailCheck, {
          className: "text-brand h-8 w-8",
          "aria-hidden": "true"
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "text-xl font-semibold",
        children: "Kolla din e-post"
      }), /*#__PURE__*/_jsxs("p", {
        className: "text-muted-foreground text-sm",
        children: ["Vi har skickat en verifieringsl\xE4nk till", " ", /*#__PURE__*/_jsx("span", {
          className: "text-foreground font-medium break-all",
          children: email
        }), ". Klicka p\xE5 l\xE4nken f\xF6r att aktivera ditt konto."]
      }), /*#__PURE__*/_jsx("p", {
        className: "text-muted-foreground text-sm",
        children: "Hittar du inget? Titta i skr\xE4pposten \u2014 l\xE4nken \xE4r giltig i en timme."
      })]
    }), resendState && /*#__PURE__*/_jsx(StatusMessage, {
      message: resendState.message,
      variant: resendState.success ? "success" : "error",
      className: "text-left"
    }), /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [onResend && /*#__PURE__*/_jsx(LoadingButton, {
        type: "button",
        variant: "outline",
        className: "w-full",
        loading: resending,
        onClick: handleResend,
        children: "Skicka l\xE4nken igen"
      }), /*#__PURE__*/_jsx(Button, {
        type: "button",
        className: "w-full",
        onClick: onDone,
        children: doneLabel
      })]
    })]
  });
}
export default CheckEmailPanel;